import axios from "axios";
import React, { ChangeEvent, useContext, useEffect, useMemo, useState } from "react";
import { usinasApi } from "../../../services/api";
import { UsinasContext } from "../context/UsinasContextProvider";
import { Grid, TextField, Typography } from "@mui/material";
import EditInvertersUsina from "./EditInvertersUsina";
import EditStringsUsina from "./EditStringsUsina";
import EditModuleUsina from "./EditModuleUsina";
import { Accordion } from "../../../main/components/accordion/Accordion";
import EditTrackersUsina from "./EditTrackersUsina";
import { MainContext } from "../../../main/context/MainContextProvider";
import BaseButton from "../../../main/components/BaseButton";
import AddIcon from "@mui/icons-material/Add";
import DangerBaseButton from "../../../main/components/DangerBaseButton";
import { Components, InverterDetails, PostUG, Producer, UG, UGDiagramData } from "../types";
import EditInvertersStringsContainer from "./EditInvertersStringsContainer";
import AdicionarUG from "./AdicionarUG";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";

import EmptyStateNotFound from "../../clients/components/EmptyState";
import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { getNumberOfUgName, ugsToPostUgs } from "../ugsMapper";
import EditUGDiagramDataUsina from "./EditUGDiagramDataUsina";
import EditSubstationUsina from "./EditSubstationUsina";

const EditUsinaContent: React.FC = () => {
  const { theme, userIsAdm, userIsClient } = useContext(MainContext);
  const primary = theme.muiTheme.palette.primary.main;

  const { usina, setUsina } = useContext(UsinasContext);
  const [, setLoading] = useState<boolean>(true);

  const path = window.location.pathname;

  const [usinaId, setUsinaId] = useState<string>("");

  useEffect(() => {
    if (path.includes("usinas/details")) {
      setUsinaId(path.split("/")[3]);
    }
    else { setUsinaId(path.split("/")[2]); }
  }, [path])

  const [editingIndex, setEditingIndex] = useState<number | null>(null);
  const [isEditing, setIsEditing] = useState<boolean>(false);

  const sortedUGs = useMemo(() => {
    if (!usina?.uGs) return [];

    return [...usina.uGs].sort((a, b) => {
      const aNumber = getNumberOfUgName(a.name);
      const bNumber = getNumberOfUgName(b.name);

      if (aNumber !== undefined && bNumber !== undefined) {
        return aNumber - bNumber;
      }
      if (aNumber !== undefined) return -1;
      if (bNumber !== undefined) return 1;

      return (a.name ?? "").localeCompare(b.name ?? "");
    });
  }, [usina?.uGs]);

  const [showDetails, setShowDetails] = useState<Array<number | null>>([]);
  const toggleDetails = (index: number) => {
    const newShowDetails = [...showDetails];
    newShowDetails[index] = showDetails[index] === index ? null : index;
    setShowDetails(newShowDetails);
  };
  // const [isCancelConfirmationOpen, setCancelConfirmationOpen] = useState(false);
  const [isSaveConfirmationOpen, setSaveConfirmationOpen] = useState(false);
  const [isRomoveConfirmationOpen, setRemoveConfirmationOpen] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);

  useEffect(() => {
    onMount();
  }, [usinaId]);

  const onMount = async () => {
    setLoading(true);
    try {
      if (usinaId) {
        const usinaResponse = await usinasApi.getUsina(usinaId);
        setUsina(usinaResponse);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        ("Erro ao coletar os dados da usina");
      }
    } finally {
      setLoading(false);
    }
  };

  // const handleEdit = (index: number) => {
  //   setEditingIndex(index);
  //   setIsEditing(true);

  // };

  const handleEdit = (index: number) => {
    if (index >= 0 && index < sortedUGs.length) {
      setEditingIndex(index);
      setIsEditing(true);
      setEditedUGName(
        getNumberOfUgName(sortedUGs[index].name)
      );
      // Inicializar o estado de inverterDetails com os dados atuais da UG
      setInverterDetailsState(
        sortedUGs[index].components?.inverterDetails || {}
      );
    }
  };

  const [dataComponentsUG, setDataComponentUG] = useState<Components>({});

  const [inverterDetailsState, setInverterDetailsState] = useState<
    Record<string, InverterDetails>
  >({});

  const handleChange = async (
    field: string,
    objectName: string,
    value?: number | string | string[] | Producer[]
  ) => {
    setDataComponentUG((prevState) => {
      return {
        ...prevState,
        [objectName]: {
          ...prevState[objectName as keyof Components],
          [field]:
            field === "producers"
              ? value !== undefined
                ? value
                : []
              : value !== undefined
                ? value
                : 0,
        },
      };
    });
  };

  // const handleCancelClick = () => {
  //   setCancelConfirmationOpen(true);
  // };
  // const [editedUGName, setEditedUGName] = useState(""); // Estado para controlar o nome editado da UG
  const [editedUGName, setEditedUGName] = useState<number | undefined>(
    undefined
  );

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setEditedUGName(Number(event.target.value)); // Atualizar o estado com o valor do input
  };

  const [editDiagramData, setEditDiagramData] = useState<UGDiagramData>({});

  const handleDiagramDataChange = async (
    field: string,
    value?: boolean | string | null
  ) => {
    setEditDiagramData((prevState) => {
      return {
        ...prevState,
        [field]: value,
      };
    });
  }

  const handleInverterDetailsChange = (
    inverterDetails: Record<string, InverterDetails>
  ) => {
    console.log("inverterDetails", inverterDetails)
    setInverterDetailsState(inverterDetails);
  };

  // Esta função recebe o nome da UG e atualiza o estado editedUGName
  // const setInitialUGName = (name: string) => {
  //   setEditedUGName(name);
  // };

  const handleSave = () => {
    setSaveConfirmationOpen(true);
  };

  // const defaultName = usina?.uGs?.[0]?.name || "";

  // const {
  //   // handleSubmit,
  //   control,
  //   formState: { errors },
  // } = useForm<UG>({
  //   defaultValues: {
  //     name: defaultName,
  //   },
  // });

  const handleSaved = async () => {
    if (editingIndex === null) {
      return;
    }
    const uGName = sortedUGs[editingIndex]?.name ?? "";
    console.log("inverterDetailsState", inverterDetailsState)

    const newUG: PostUG = {
      number: editedUGName || getNumberOfUgName(uGName),
      disjuntorTag: editDiagramData.disjuntorTag ?? "",
      hasSmartLogger: editDiagramData.hasSmartLogger ?? false,
      hasTransformer: editDiagramData.hasTransformer ?? false,
      components: {
        inverters: {
          amount: dataComponentsUG.inverters?.amount,
          inverterPower: dataComponentsUG.inverters?.inverterPower,
          producers: dataComponentsUG.inverters?.producers,
          firstInverterNumber: dataComponentsUG.inverters?.firstInverterNumber,
        },
        inverterDetails: inverterDetailsState,
        modules: {
          amount: dataComponentsUG.modules?.amount,
          power: dataComponentsUG.modules?.power,
          producers: dataComponentsUG.modules?.producers,
        },
        string: {
          amount: dataComponentsUG.string?.amount,
          power: dataComponentsUG.string?.power,
        },
        trackers: {
          amount: dataComponentsUG.trackers?.amount,
          producers: dataComponentsUG.trackers?.producers,
        },
      },
    };

    const filterUgs = ugsToPostUgs(
      usina?.uGs?.filter((ug) => ug.name != uGName)
    );

    const newUgs = filterUgs ? [...filterUgs, newUG] : [newUG];
    try {
      await usinasApi.patchUsina(usinaId, { uGs: newUgs });
      setEditingIndex(null);
      setIsEditing(false);
      onMount();
    } catch (error) {
      console.error("Erro ao salvar procedimentos de edição:", error);
    } finally {
      setEditingIndex(null);
      setIsEditing(false);
    }

    setEditingIndex(null);
    setIsEditing(false);
  };

  const onClose = () => {
    setEditingIndex(null);
    setIsEditing(false);
  };

  const [removedUG, setRemovedUG] = useState<UG>();

  const handleRemoveUG = async () => {
    const updatedUsina = { ...usina } as { uGs?: PostUG[] };
    const updatedUGs = [...(updatedUsina.uGs || [])] as PostUG[];

    const indexToRemove = updatedUGs.findIndex(
      (ug) => ug.number === removedUG?.name
    );

    if (indexToRemove !== -1) {
      updatedUGs.splice(indexToRemove, 1);

      updatedUsina.uGs = updatedUGs;

      try {
        await usinasApi.patchUsina(usinaId, updatedUsina);
        onMount();
      } catch (error) {
        console.error("Erro ao remover a UG do servidor:", error);
      }
    } else {
      console.warn("UG não encontrada no array.");
    }

    // Fecha o modal de confirmação
    setRemoveConfirmationOpen(false);
  };

  const handleClickRemove = (ug: UG) => {
    setRemovedUG(ug);
    setRemoveConfirmationOpen(true);
  };

  const [isRegisterUG, setRegisterUG] = useState(false);

  const addUG = () => {
    setRegisterUG(true);
  };

  const closeAddUG = () => {
    setRegisterUG(false);
  };

  return (
    <>
      <EditSubstationUsina
        onMount={onMount}
        usinaId={usina?.usinaIds.id ?? ""}
        substation={usina?.substation} />
      {sortedUGs.length > 0 && sortedUGs.some((uG) => uG.components) ? (
        sortedUGs.map((uG, index) => (
          <Grid key={`${uG.name ?? "ug"}-${index}`} sx={{ marginBottom: "30px" }}>
            <Accordion.Root>
              <Accordion.Header
                toggleDetails={() => toggleDetails(index)}
                showDetails={showDetails[index] === index}
                // title={editingIndex !== index ? editedUGName || "" : ""}
                title={uG.name || ""}
                typographySx={{ fontSize: { xs: "13px", sm: "16px" } }}
              >
                <Typography></Typography>
              </Accordion.Header>
              <Accordion.Content
                showDetails={showDetails[index] === index}
                sx={{}}
              >
                <Grid container>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {(userIsAdm || userIsClient) && editingIndex !== index && (
                      <BaseButton
                        title="Editar"
                        onClick={() => handleEdit(index)}
                        sx={{
                          backGroundColor: primary,
                          borderColor: primary,
                          "& .MuiTypography-root": {
                            color: primary,
                          },
                          "&:hover": {
                            borderColor: primary,
                            backgroundColor: primary,
                            color: primary,
                            "& .MuiTypography-root": {
                              color: "#FFFFFF",
                            },
                          },
                          marginLeft: "auto",
                          width: "12%",
                          height: "30px",
                        }}
                      />
                    )}
                    {(userIsAdm || userIsClient) && (
                      <DangerBaseButton
                        title="Remover UG"
                        onClick={() => handleClickRemove(uG)}
                        sx={{
                          height: "30px",
                          marginLeft: "10px",
                        }}
                      />
                    )}
                  </Grid>
                  {/* Conteúdo principal aqui */}
                  {editingIndex === index && (userIsAdm || userIsClient) && (
                    <Grid
                      sx={{
                        padding: "20px",
                        flexDirection: "row",
                        // display: "flex",
                        backgroundColor: "rgba(217, 217, 217, 0.1)",
                        borderRadius: 2,
                        marginTop: "8px",
                        marginBottom: "8px",
                        rowGap: "16px ",
                        width: "100%",
                      }}
                    >
                      <Grid item xs={6} textAlign={"start"}>
                        <Typography sx={{ py: "10px" }}>
                          Número da UG
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <TextField
                          type="number"
                          // label="Nome da UG"
                          size="small"
                          inputProps={{ min: 0 }}
                          value={editedUGName}
                          onChange={handleInputChange}
                          // onFocus={() => setInitialUGName(uG.name || "")}
                          sx={{ width: "100%" }}
                        />
                      </Grid>
                    </Grid>
                  )}
                  <EditUGDiagramDataUsina
                    uG={{
                      ...uG,
                      disjuntorTag: uG.disjuntorTag,
                      hasSmartLogger: uG.hasSmartLogger,
                      hasTransformer: uG.hasTransformer,
                    }}
                    isEditing={isEditing}
                    updateStateContent={handleDiagramDataChange}
                    setIsEditing={setIsEditing}
                  />
                  <EditInvertersUsina
                    uG={{
                      ...uG,
                      components: {
                        inverters: {
                          ...uG.components?.inverters,
                          producers: uG.components?.inverters?.producers || [],
                        },
                      },
                    }}
                    isEditing={isEditing}
                    updateStateContent={handleChange}
                    setIsEditing={setIsEditing}
                  />
                  <EditStringsUsina
                    uG={{
                      ...uG,
                      components: {
                        string: uG.components?.string,
                      },
                    }}
                    isEditing={isEditing}
                    updateStateContent={handleChange}
                    setIsEditing={setIsEditing}
                  />
                  <EditInvertersStringsContainer
                    invertersAmount={uG.components?.inverters?.amount || 0}
                    totalStrings={uG.components?.string?.amount || 0}
                    firstInverterNumber={uG.components?.inverters?.firstInverterNumber || 1}
                    inverterDetails={uG.components?.inverterDetails}
                    isEditing={isEditing}
                    onInverterDetailsChange={handleInverterDetailsChange}
                  />
                  <EditTrackersUsina
                    uG={{
                      ...uG,
                      components: {
                        trackers: {
                          ...uG.components?.trackers,
                          producers: uG.components?.trackers?.producers || [],
                        },
                      },
                    }}
                    isEditing={isEditing}
                    updateStateContent={handleChange}
                    setIsEditing={setIsEditing}
                  />
                  <EditModuleUsina
                    uG={{
                      ...uG,
                      components: {
                        modules: {
                          ...uG.components?.modules,
                          producers: uG.components?.modules?.producers || [],
                        },
                      },
                    }}
                    isEditing={isEditing}
                    updateStateContent={handleChange}
                    setIsEditing={setIsEditing}
                  />

                  {(userIsAdm || userIsClient) && editingIndex === index && (
                    <Grid
                      item
                      xs={12}
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        alignItems: "center",
                      }}
                    >
                      <BaseButton
                        title="Salvar"
                        onClick={handleSave}
                        sx={{
                          backGroundColor: primary,
                          borderColor: primary,
                          "& .MuiTypography-root": {
                            color: primary,
                          },
                          "&:hover": {
                            borderColor: primary,
                            backgroundColor: primary,
                            color: primary,
                            "& .MuiTypography-root": {
                              color: "#FFFFFF",
                            },
                          },
                          marginRight: "8px",
                          width: "10%",
                          height: "30px",
                        }}
                      />
                      <DangerBaseButton
                        title="Cancelar"
                        onClick={onClose}
                        sx={{
                          width: "10%",
                          height: "30px",
                        }}
                      />
                    </Grid>
                  )}
                </Grid>
              </Accordion.Content>
            </Accordion.Root>
          </Grid>
        ))
      ) : (
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyStateNotFound title="Ainda não há nenhuma UG cadastrada! Clique no botão para adicionar." />
        </Grid>
      )}
      <>
        <Grid
          item
          xs={12}
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
          }}
        >
          {(userIsAdm || userIsClient) && !isRegisterUG && (
            <BaseButton
              title="Adicionar UG"
              startIcon={<AddIcon />}
              onClick={addUG}
              sx={{
                width: "150px",
                height: "40px",
                marginTop: "20px",
              }}
            />
          )}
        </Grid>
        {(userIsAdm || userIsClient) && isRegisterUG && (
          <AdicionarUG
            onClose={closeAddUG}
            usina={usina}
            onMount={onMount}
            isEditing={isEditing}
          />
        )}
      </>
      {/* <ConfirmationDialog
        open={isCancelConfirmationOpen}
        title="Descartar Edição"
        message="Deseja descartar e cancelar a edição desta UG?"
        onConfirm={onClose}
        onCancel={() => setCancelConfirmationOpen(false)}
        onClose={() => setCancelConfirmationOpen(false)}
      /> */}
      <ConfirmationModal
        open={isSaveConfirmationOpen}
        setOpen={() => setSaveConfirmationOpen(false)}
        title="Editar UG"
        contentText="Deseja confirmar a edição da UG?"
        onConfirm={handleSaved}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ConfirmationModal
        open={isRomoveConfirmationOpen}
        setOpen={() => setRemoveConfirmationOpen(false)}
        title="Remover UG"
        contentText="Deseja confirmar a remoção da UG?"
        onConfirm={handleRemoveUG}
        setOpenErrorModal={setOpenErrorModal}
        setOpenSuccessModal={setOpenSuccessModal}
      />
      <ActionAlert
        message="A edição da UG foi realizada com sucesso!"
        severity="success"
        open={openSuccessModal}
        setOpen={() => setOpenSuccessModal(false)}
      />
      <ActionAlert
        message="Ocorreu um erro ao editar a UG! Tente novamente mais tarde."
        severity="error"
        open={openErrorModal}
        setOpen={setOpenErrorModal}
      />
    </>
  );
};

export default EditUsinaContent;
